<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <blue-title class="style">结算银行账户</blue-title>
      <BankInfo
        :backList="backList"
        :provinceListData="provinceListData"
        :cityListData="cityListData"
        :subBranch="subBranch"
        :count.sync="count"
        :allData="allData"
        :otherBankList="otherBankList"
        @changeBack="changeBack"
        @changeProvince="changeProvince"
        @changeCity="changeCity"
        @confirm="handleValidityBack"
        @changeSubBranch="changeSubBranch"
      ></BankInfo>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="info" @click="count++">保存草稿</el-button>
        <el-button type="primary" @click="count++">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import BankInfo from '../../components/bankInfo/bankInfo';
import {
  accountTypeQuery,
  provinceCityQuery,
  provinceList,
  cityList,
  saveEditDraft,
  draftEcho,
  otherBank,
} from '../../../../api/module/merchants';

export default {
  components: {
    BankInfo,
  },
  props: {},
  data() {
    return {
      subBranchInfo: {
        city: '',
        bankName: '',
      },
      BackInfo: {
        bankAccountType: 'BANK_ACCOUNT_TYPE_CORPORATE',
        accountName: '',
        bankAddressCode: '',
        bankBranchId: '',
        bankName: '',
        accountNumber: '',
        province: '',
        city: '',
        isSameAccount: 0,
        subBranch: '',
        accountBranch: '',
        backName: '',
        accountBank: '',
        accountBranchName: '',
      },
      backList: [],
      provinceListData: [],
      cityListData: [],
      subBranch: [],
      BackPass: false,
      count: 0, // 是否开始验证
      allData: {},
      otherBankList: [],
      isOtherBank: false,
      isSubBranch: false,
    };
  },

  computed: {
    id() {
      return this.$route.query.id;
    },
    type() {
      return this.$route.query.type;
    },
    subjectName() {
      return this.$route.query.subjectName;
    },
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
  },
  watch: {},
  created() {
    this.accountTypeQuery();
    this.provinceList();
    if (this.type == 'edit') {
      this.draftEcho();
    }
  },
  methods: {
    async draftEcho() {
      const result = await draftEcho({
        uuid: this.uuid,
      });
      this.cityList(result.settlementBankAccountVO.province);
      this.subBranchInfo.bankName = result.settlementBankAccountVO.accountBank;
      this.subBranchInfo.city = result.settlementBankAccountVO.city;
      this.provinceCityQuery();
      this.allData = result;
      console.log('回显所填信息', result);
    },
    // 验证银行信息
    handleValidityBack({ flag, ruleForm }) {
      this.BackInfo = { ...ruleForm };
      this.BackPass = flag;
      this.handleSave();
    },
    handleSave() {
      const { BackPass } = this;
      if (BackPass) {
        console.log('成功');
        const obj = this.formatSubmitData();
        console.log('处理后的数据===', obj);
        this.saveEditDraft(obj);
      }
    },
    formatSubmitData() {
      let obj = {};
      // const { id } = this.$route.query;
      const { BackInfo, isOtherBank, isSubBranch, uuid, merchantId } = this;
      obj = {
        settlementBankAccountVO: {
          accountBank: BackInfo.accountBank,
          accountName: BackInfo.accountName,
          accountNumber: BackInfo.accountNumber,
          bankAccountType: BackInfo.bankAccountType,
          isSameAccount: BackInfo.isSameAccount,
          bankAddressCode: BackInfo.bankAddressCode,
          bankBranchId: BackInfo.bankBranchId,
          bankName: BackInfo.bankName,
          province: BackInfo.province,
          city: BackInfo.city,
          backName: isOtherBank ? BackInfo.backName : '',
          accountBranch: BackInfo.accountBranch,
          accountBranchName: isSubBranch ? BackInfo.accountBranchName : '',
          createTime: '',
          id: 0,
          status: 0,
          updateTime: '',
          uuid: '',
        },
        uuid,
        merchantId,
        type: 'settlementBank',
        listVO: {
          status: 0,
          subjectType: this.subjectName,
          merchantType: this.facilitatorName,
        },
      };
      return obj;
    },
    async saveEditDraft(obj) {
      console.log(obj);
      // const result = await saveEditDraft({ ...obj });
      try {
        const result = await saveEditDraft({ ...obj });
        console.log('保存结果', result);
        this.$message({
          message: '保存成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$router.replace({
              path: '/merchants/addMerchants',
              query: {
                id: this.id,
                subjectName: this.subjectName,
                facilitatorName: this.facilitatorName,
                type: 'edit',
                uuid: result,
                merchantId: this.merchantId
              },
            });
          },
        });
      } catch (err) {
        this.$message({
          message: '保存失败',
          type: 'warring',
          duration: 1500,
        });
      }
    },
    async accountTypeQuery() {
      const result = await accountTypeQuery({});
      console.log('列表', result);
      this.backList = result;
    },
    async provinceList() {
      const result = await provinceList({});
      this.provinceListData = result;
    },
    async cityList(val) {
      const result = await cityList({
        provinceCode: val,
      });
      this.cityListData = result;
    },
    changeProvince(val) {
      this.cityList(val);
    },
    changeBack(val) {
      console.log(val);
      this.subBranchInfo.bankName = val;
      if (val == '其他银行') {
        this.isOtherBank = true;
        this.otherBank();
      } else {
        this.isOtherBank = false;
      }
    },
    changeSubBranch(val) {
      if (val == '其他银行') {
        this.isSubBranch = true;
      } else {
        this.isSubBranch = false;
      }
    },
    changeCity(val) {
      this.subBranchInfo.city = val;
      this.provinceCityQuery();
    },
    back() {
      this.$router.replace({
        path: '/merchants/addMerchants',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    async otherBank() {
      const result = await otherBank({});
      this.otherBankList = result;
      console.log('111111', result);
    },
    async provinceCityQuery() {
      const { bankName, city } = this.subBranchInfo;
      const result = await provinceCityQuery({
        city,
        bankName,
      });
      this.subBranch = result;
      this.subBranch.push('其他银行');
      console.log('111111', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  padding-top: 20px;
  .style {
    margin-bottom: 9px;
  }
  .btn {
    box-sizing: border-box;
    padding-left: 31px;
    margin-top: 57px;
    padding-bottom: 100px;
  }
}
</style>
